/**
 * Supported countries for business profiles.
 */
export const COUNTRIES = [
  'kr',   // South Korea
  'us',   // United States
  'gu',   // Guam
  'th',   // Thailand
  'sg',   // Singapore
  'hk',   // Hong Kong
  'id',   // Indonesia
  'vn',   // Vietnam
  'jp',   // Japan
  'au',   // Australia
  'gb',   // United Kingdom
] as const;

export type CountryCode = (typeof COUNTRIES)[number];
